module.exports = __webpack_public_path__ + "img/backyard-pond-straight-on.22e15039.webp";